<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import Vue from "vue";
// import instance from './api/index.js';
import * as user from "@/common/api/user";
import * as util from "./assets/util.js";
// import AllRoutesData from "@/layout/index";
import Router from "vue-router";
import AllRoutesData from "./router/modul/fullpath.js";
import instance from "./api";
import { _setSessionStore, _getSessionStore } from "@/utils/storage";
import { getUserMenu } from "./api/user.js";
import { tableInShow } from "@/assets/hasShow.js";
export default {
  name: "app",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      // menuData: null,
      isRouterAlive: true
    };
  },
  created: function() {
    // this.$root.menuData = AllRoutesData;
    this.signin(this.initUser);
  },
  // beforeMount: function(){
  // },
  // mounted: function(){
  // },
  beforeUpdate: function() {},
  // updated: function(){
  // },
  // beforeDestroy: function(){
  // },
  // destroyed: function(){
  // },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    setInterceptor: function(resourcePermission) {
      // 设置资源权限
      // eslint-disable-next-line no-undef
      instance.interceptors.request.use(config => {
        // Get request path
        let perName = config.url.replace(config.baseURL, "").split("?")[0];
        // Check permissions

        if (!resourcePermission[config.method + "," + perName]) {
          return Promise.reject({
            message: config.method + "," + perName + "无访问权限"
          });
        }
        return config;
      });
    },
    extendRoutes: function(routePermission) {
      let actualRouter = [];
      let findLocalRoute = function(array, base) {
        let replyResult = [];
        array.forEach(route => {
          let pathKey = (base ? base + "/" : "") + route.path;

          if (routePermission[pathKey]) {
            if (Array.isArray(route.children)) {
              route.children = findLocalRoute(
                route.children,
                (base ? base + "/" : "") + route.path
              );
            }

            replyResult.push(route);
          }
        });
        if (base) {
          return replyResult;
        } else {
          actualRouter = actualRouter.concat(replyResult);
        }
      };
      findLocalRoute(AllRoutesData[0].children);
      // If the user does not have any routing authority

      if (!actualRouter || !actualRouter.length) {
        // clear token, refresh page will jump to login screen.
        // util.storage('auth','');
        // Interface hints
        return (document.body.innerHTML =
          "<h1>账号访问受限，请联系系统管理员！</h1>");
      }
      actualRouter = actualRouter.map(e => {
        // Copy 'children' to 'meta' for rendering menu.(This step is optional.)

        if (e.children) {
          if (!e.meta) {
            e.meta = {};
          }

          e.meta.children = e.children;
        }

        return e;
      });
      // Add actual routing to application
      let originPath = util.deepcopy(AllRoutesData);
      // let go404 = originPath
      originPath[0].children = actualRouter;
      // originPath[0].children.push(AllRoutesData[AllRoutesData.length-1])
      this.$router.addRoutes(
        originPath.concat([
          {
            path: "*",
            redirect: "/404"
          }
        ])
      );
      // if(){}
      this.$root.menuData = originPath[0].children;
      //
      // // Save information for rendering menu.(This step is optional.)
      //
      // store.set('menu', actualRouter)
    },

    // 77777777777777777
    // cf
    getResources: function(userPermissions) {
      let resourceHash = {};
      if (Array.isArray(userPermissions)) {
        userPermissions.forEach(e => {
          let key = e.method.toLowerCase() + "," + e.url;
          resourceHash[key] = true;
        });
      }

      // Get hash structure
      return resourceHash;
    },
    getRoutes: function(userPermissions) {
      let routeHash = {};
      let setMenu2Hash = function(array, base) {
        array.map(key => {
          if (key.url) {
            let hashKey = (base ? base + "/" : "") + key.url;
            // .replace(
            // 	/ ^\/ /,
            // 	""
            // );

            routeHash["" + hashKey] = true;
            if (Array.isArray(key.children)) {
              setMenu2Hash(key.children);
            }
          }
        });
      };
      if (Array.isArray(userPermissions)) {
        setMenu2Hash(userPermissions);
      }
      // Get hash structure
      return routeHash;
    },

    signin: function(callback) {
      let that = this;
      /*
       * Step 1
       * 检查用户是否具有访问权限
       */
      let tokenUser = util.session("token");
      let localUser = _getSessionStore("auth", "JSONStr");
      let localUrl = _getSessionStore("auth_rule", "JSONStr");
      if (!tokenUser) {
        return that.$router.push({
          path: "/login"
        });
      }
      let arrayMenus = util.buildMenu(localUser);

      // /*
      // * Step 2
      // * 设置授权
      // */
      //
      // instance.defaults.headers.common['Authorization'] = sessionStorage.getItem("token")
      // instance.defaults.headers.common['Authorization'] = localUser.accessToken;
      // // Update token info
      // try{
      //   const tokenInfoPart = localUser.accessToken.split('.')[1];
      //   const tokenInfo = JSON.parse(atob(tokenInfoPart));
      //   store.set('tokenInfo', tokenInfo)
      // }catch(err) {
      // }

      /*
				
				 * Step 2-1(这一步是可选的)
				 * 得到用户的权限
				 * 您还可以在用户登录时获得权限信息，这取决于后端接口的实现
				 */
      // 后台穿过来的路由哈希映射
      // let resourcePermission = that.getResources(localUrl);
      // let zxc = that.setInterceptor(resourcePermission);

      let routePermission = that.getRoutes(localUser);
      that.extendRoutes(routePermission);
      // this.$root.AccessControl
      if (this.$root.AccessControl) {
        user.getPermission().then(res => {
          let userPermissions = res;
          _setSessionStore("permission", userPermissions);

          /*
           * Step 3
           * Get resourcePermission form user permissions
           * Like this:
           * { "get,/url1": true, "post,/url2": true, ... }
           */

          // let resourcePermission = that.getResources(userPermissions);

          /*
           * Step 4
           * Get routePermission form user permissions
           * Like this:
           * { "/route1": true, "/route2": true, ... }
           */

          /*
           * Step 5
           * Setting request permission control through resourcePermission
           */

          // that.setInterceptor(resourcePermission);

          /*
           * Step 6
           * Adding routing privileges to users
           */

          that.extendRoutes(routePermission);

          /*
           * Step 7
           * Implementing $_has function, support for the directive "has" (in /main.js)
           * Input: Array, like this: ['get,/some-uri']
           * Output: Boolean
           */

          Vue.prototype.$_has = function(rArray) {
            let RequiredPermissions = [];
            let permission = true;
            let regex = new RegExp(/\.([^(]+)\("([^"]+)"/);

            if (Array.isArray(rArray)) {
              rArray.forEach(e => {
                const res = e.toString().match(regex);
                if (res && res.length > 2) {
                  RequiredPermissions.push([res[1], res[2]].join(","));
                }
              });
            } else if (typeof rArray === "function") {
              const res = rArray.toString().match(regex);
              if (res && res.length > 2) {
                RequiredPermissions.push(
                  [res[1].trim(), res[2].trim()].join(",")
                );
              }
            }
            // for (let i = 0; i < RequiredPermissions.length; i++) {
            //   let p = RequiredPermissions[i];
            //   if (!resourcePermission[p]) {
            //     permission = false;
            //     break;
            //   }
            // }

            return permission;
          };

          typeof callback === "function" && callback();
        });
      } else {
        //无权限控制
        // this.$router.addRoutes(
        //   AllRoutesData.concat([
        //     {
        //       path: "*",
        //       redirect: "/404"
        //     }
        //   ])
        // );
        // const currentUserMenu = AllRoutesData[0].children.map(e => {
        //   if (!e.meta) {
        //     e.meta = {};
        //   }
        //   return e;
        // });
        // _setSessionStore("menu", currentUserMenu);

        typeof callback === "function" && callback();
      }
    },
    initUser: function() {
      // 如果当前是登录页，跳回首页
      if (this.$router.currentRoute.path == "/login") {
        this.$router.replace({
          path: "/"
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
